import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components'
import { fetchRaffleList } from './api'
import moment from 'moment'
import ListView from '@/components/ListView/list-view'
import Header from '@/components/Header'
import { popNativePage } from "@/utils";

const RaffleDetail = () => {
  const lastId = useRef('')
  const [list, setList] = useState([])
  const loadingRef = useRef(false);
  const loadAll = useRef(false);
  const listRef = useRef([]);
  listRef.current = list

  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    if (loadingRef.current || loadAll.current) {
      return;
    }
    loadingRef.current = true;
    fetchRaffleList({ activityId: 230, lastId: lastId.current, pageSize: 20 }).then(res => {
      const data = res.data || [];
      const nextList = [...listRef.current, ...data]
      setList(nextList)
      const last = data[data.length - 1];
      if (last) {
        lastId.current = last.id
      }
      if (data.length < 20) {
        loadAll.current = true;
      }

      loadingRef.current = false;
    }).catch(err => {
      loadingRef.current = false;
    })
  }

  const formatDate = (date) => {
    if (!date) {
      return ''
    }
    return moment(date).format('YYYY-MM-DD HH:mm')
  }

  const handleReachBottom = () => {
    getData();
  }

  return (
    <Container>
      <Header
        title={'抽奖次数明细'}
        leftClick={popNativePage}
      />
      <div className="award-title flex-between">
        <span>类型/时间</span>
        <span>抽奖次数</span>
      </div>
      <ListView onReachBottom={handleReachBottom} className="list-wrap">
        {list.map(item => {
          return (
            <div key={item.id} className="award-item">
              <div className="flex-between award-head">
                <span>{item.reason}</span>
                <span className={item.count > 0 ? 'red' : 'green'}>{item.count > 0 ? `+${item.count}` : item.count}</span>
              </div>
              {item.postContent && <div className="award-desc">帖子摘要：{item.postContent}</div>}
              <div className="arard-time">{formatDate(item.createTime)}</div>
            </div>
          )
        })}
      </ListView>
    </Container>
  )
}

export default RaffleDetail;

const Container = styled.div`
  background-color: #F3F4F9;
  height: 100vh;
  box-sizing: border-box;
  padding-top: 44px;
  .award-title {
    height: 36px;
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
    line-height: 17px;
    padding: 0 16px;
  }
  .award-item {
    height: 100px;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 16px 16px 0;
    border-bottom: 1px solid #E5E5E5;
    .award-head {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 6px;
    }
  }
  .arard-time {
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
    line-height: 17px;
  }
  .award-desc {
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
    line-height: 17px;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .award-type {
    font-weight: 500;
    font-size: 16px;
    color: #4074FE;
    line-height: 22px;
  }
  .red {
    color: #FF2848;
  }
  .green {
    color: #1AB41A;
  }
`;